// 7ot rfce b3dn tab by5la2o

import React from 'react'
import HomePages from "../Components/homep/homepage";

function HomePage() {
  return (
    <HomePages />
  )
}

export default HomePage

